export default __webpack_public_path__ + "static/media/exportIcon.f1cf36ff.svg";